import request from '@/utils/request'

let ReserveApi = {
  /*预约列表*/
  reserveList(data) {
    return request._post('/shop/plus.reserve.reserve/index', data);
  },

  /*预约详情*/
  reserveDetail(data) {
    return request._post('/shop/plus.reserve.reserve/detail', data);
  },

  extract(data) {
    return request._post('/shop/plus.reserve.reserve/edit', data);
  },
  
  check(data) {
    return request._post('/shop/plus.reserve.reserve/check', data);
  },

  /*门店列表*/
  shoplist(data) {
    return request._post('/shop/plus.reserve.store/index', data);
  },

  /*编辑*/
  editShop(data) {
    return request._post('/shop/plus.reserve.store/edit', data);
  },

  /*sku列表*/
  skuList(data) {
    return request._post('/shop/plus.reserve.sku/index', data);
  },

  /*编辑*/
  editSku(data) {
    return request._post('/shop/plus.reserve.sku/edit', data);
  },

  /*编辑*/
  getSetting(data) {
    return request._get('/shop/plus.reserve.setting/index', data);
  },

  /*编辑*/
  saveSetting(data) {
    return request._post('/shop/plus.reserve.setting/index', data);
  },
}

export default ReserveApi;



// WEBPACK FOOTER //
// ./src/api/reserve.js